import { css, FlattenSimpleInterpolation } from 'styled-components';
import {
	grayBlueMuted, navyDeepest, labelBlueBg, labelBlueText,
	labelSuccessBg, labelSuccessText, labelWarningBg, labelWarningText,
	dangerLight, labelDangerText,
} from '../themes/colors';

export const labelVariants = <const> [
	'neutral',
	'informational',
	'success',
	'warning',
	'critical',
	'secondary',
];

export type LabelVariant = typeof labelVariants[number];

export const LabelVariantCssDefinition: { [key in LabelVariant]: FlattenSimpleInterpolation } = {
	neutral: css`
		background-color: ${grayBlueMuted};
		color: ${navyDeepest};
	`,
	informational: css`
		background-color: ${labelBlueBg};
		color: ${labelBlueText};
	`,
	success: css`
		background-color: ${labelSuccessBg};
		color: ${labelSuccessText};
	`,
	warning: css`
		background-color: ${labelWarningBg};
		color: ${labelWarningText};
	`,
	critical: css`
		background-color: ${dangerLight};
		color: ${labelDangerText};
	`,
	secondary: css`
		background-color: ${grayBlueMuted};
		color: ${navyDeepest};
	`
};
